<template>
  <el-dialog title="Pré-postagem" :append-to-body="false" center :visible.sync="dialog">
    <el-card shadow="never">
      <CalculateResultItem :header="true" />
      <CalculateResultItem :header="false" 
        v-for="itemData of tableData" 
        :key="itemData.id" 
        :modality="itemData.name" 
        :deadline="itemData.quantityDays" 
        :logo="itemData.logo" 
        :price="itemData.pricetable" 
        :cash="0" 
        :savings="0" 
        :data="itemData" 
        label="Selecionar"
        @redirect="redirect"
        />
    </el-card>
    <span slot="footer" class="dialog-footer">
      <el-button type="default" @click.stop.prevent="dialog = false">Cancelar</el-button>
    </span>
  </el-dialog>

</template>

<script>
import CalculateResultItem from '../calculate/CalculateResultItem.vue';

export default {
  name: 'PostEditWeight',
  data() {
    return {
      dialog: false,
      tableData: [],
      ruleForm: {
        weight: 0,
        length: 0,
        width: 0,
        height: 0,
      }
    };
  },
  methods: {
    setup(data) {
      const tableData = JSON.parse(localStorage.getItem("QUOTATION"));
      this.tableData = tableData;
      this.dialog = true;
    },
    redirect() {
      console.log('emit service')
      this.dialog = false;
      this.$emit('redirect');
    }
  },
  components: { CalculateResultItem }
}
</script>